export default {
  methods: {
    validateAutoApprove() {
      const findAutoApproveComponents = (component) => {
        let components = [];
          
        if (component.$options.name === 'UserFieldAutoApproveExtra') {
          components.push(component);
        }
          
        if (component.$children) {
          component.$children.forEach(child => {
            components = components.concat(findAutoApproveComponents(child));
          });
        }
          
        return components;
      };
        
      const autoApproveComponents = findAutoApproveComponents(this);
        
      for (const component of autoApproveComponents) {
        if (!component.validate()) {
          return false;
        }
      }
        
      return true;
    }
  }
} 